import React from 'react';
import { Box, Typography, Link, Container } from '@mui/material';

export default function Footer() {
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 6,
        textAlign: 'center'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ mb: 3 }}>
          <Link 
            href="/privacy" 
            sx={{ 
              mx: 2, 
              color: 'text.primary',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            Privacy Policy
          </Link>
          <Link 
            href="/terms" 
            sx={{ 
              mx: 2, 
              color: 'text.primary',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            Terms of Use
          </Link>
        </Box>
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ fontSize: '0.875rem' }}
        >
          © {new Date().getFullYear()} Tivra (a product of CRAFX LLC). All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
} 